
import { Component, Vue, Prop } from "vue-property-decorator";
import iconImage from "./assets/icons/people.svg";

const CLASS_HORIZONTAL = "horizontal";

@Component
export default class ComplianceBlock extends Vue {
  @Prop({ type: Boolean, default: false }) readonly horizontal!: boolean;
  @Prop({
    type: [Object, String],
    required: false,
    default: () => ({}),
  })
  readonly service?: Record<string, any> | string;

  ICON_IMAGE = iconImage;

  get classes() {
    const { horizontal } = this;

    return {
      [`${CLASS_HORIZONTAL}`]: horizontal,
    };
  }

  getDependentVisa() {
    if (!(typeof this.service === "object" && this.service?.ID)) return;

    this.$root.$emit("get-dependant-visa", {
      serviceId: this.service.ID,
    });
  }
}
